import {defineStore} from 'pinia';

// 存储所有动态创建的 Store 实例
const dynamicStores = new Map<string, any>();

export function createDynamicStore(
  storeDefinition: any,
  storeId: string
) {
  const storeKey = `${storeDefinition.name}-${storeId}`;

  // 动态生成唯一 Store ID
  if (!dynamicStores.has(storeKey)) {
    const store = defineStore(storeKey, storeDefinition)();
    dynamicStores.set(storeKey, store);
  }
  // console.error(dynamicStores.get(storeKey), "=======use======")
  return dynamicStores.get(storeKey);
}

export function clearAllStores() {

}
